export const checkIsFailure = (status: number) =>
  status !== 200 && status !== 201 && status !== 202 && status !== 204

export const checkIsNotFound = (status: number) =>
  status === 404
